export default "__VITE_ASSET__DeCj0giE__"